var map = {
	"./A_research.png": 3987,
	"./B_research.png": 3570,
	"./C_research.png": 4377,
	"./D_research.png": 1104,
	"./E_research.png": 1487,
	"./F_research.png": 1918,
	"./G_research.png": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9093;